export default [
  {
    name: "Utilisateurs",
    icon: "fa fa-users",
    path: "/users",
  },
];
